import { useContext } from 'react'
import { navigate } from 'gatsby-plugin-intl'

import PauseIcon from '@icons/Pause'
import PlayIcon from '@icons/Play'
import { StoreContext } from '@models/Store'
import { useTranslation } from '@models/Translation'
import { checkMaxAudioCount } from '@models/Voice'
import { Article } from '@models/Article'

import playingGif from './assets/playing.gif'
import playingBlackGif from './assets/playing-black.gif'
import * as style from './style.module.sass'

type VoicePlayButtonProps = {
  article: Article
  type?: 'list' | 'list-white' | 'detail' | 'detail-artisan'
}
const VoicePlayButton = ({ article, type = 'list' }: VoicePlayButtonProps) => {
  const { t } = useTranslation()
  const { entity, action } = useContext(StoreContext)
  const { voice } = entity
  const isCurrentArticle = voice.articleIds[voice.playIndex] === article.blogId
  const isMasked = entity?.user?.isSignIn !== true && article.isMembersOnly

  const play = async () => {
    if (entity.user?.isSignIn !== true && article.blogId !== 'audio_info_02') {
      if (checkMaxAudioCount()) {
        navigate(`/signup?limit=voice&redirect=${article.path}`)
        return
      }
    }

    action.setVoiceArticleIds([article.blogId])
  }

  const playPause = () => {
    action.setVoiceIsPlaying(!voice.isPlaying)
  }

  const click = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault()

    if (isCurrentArticle) {
      playPause()
      return
    }

    play()
  }

  if (type === 'list' || type === 'list-white') {
    return (
      <button
        className={style.listButton}
        onClick={click}
        data-show={entity.user !== undefined && !isMasked}
        data-active={voice.isPlaying && isCurrentArticle}
        data-type={type}
      >
        <div className={style.circle}>
          {voice.isPlaying && isCurrentArticle ? (
            <img
              src={type === 'list' ? playingGif : playingBlackGif}
              alt="playing"
            />
          ) : (
            <PlayIcon />
          )}
        </div>
      </button>
    )
  }

  return (
    <div
      className={style.voice}
      data-show={entity.user !== undefined && !isMasked}
    >
      <button
        className={style.play}
        onClick={click}
        data-active={voice.isPlaying && isCurrentArticle}
      >
        {voice.isPlaying && isCurrentArticle ? (
          <>
            <PauseIcon />
            {t('voice.stop')}
          </>
        ) : (
          <>
            <PlayIcon />
            {t('voice.listen')}
          </>
        )}
      </button>
      <div
        className={style.notice}
        data-artisan={type === 'detail-artisan'}
        dangerouslySetInnerHTML={{ __html: t('voice.notice') }}
      />
    </div>
  )
}

export default VoicePlayButton
